import React from 'react';
import { noTimeoutClient } from 'src/api/client';
import { CUMA_AI_URL } from 'src/config/api';
import { configByPlatform } from 'src/config/platform';
import { getToken } from 'src/hooks/useLocalStorage';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    top: 60px;
    right: 30px;
    gap: 16px;
    z-index: 3;

    .text {
        position: relative;
        background: #fff;
        padding: 8px 12px;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

        font-size: 14px;
        height: 36px;
        line-height: 1.4;

        border-radius: 8px;

        &:after {
            /* display: flex; */
            position: absolute;
            content: '';
            width: 8px;
            height: 8px;
            right: -4px;
            transform: translateY(50%) rotate(45deg);
            background: #fff;
        }
    }

    button {
        width: 80px;
        height: 80px;
        background: #d4e8fa;
        border-radius: 50%;
    }
`;

function CumaAIButton() {
    const [isHovering, setIsHovering] = React.useState(false);
    const onClick = React.useCallback(async () => {
        const token = getToken();
        const url = new URL(CUMA_AI_URL);
        url.searchParams.append('token', token);
        url.searchParams.append('userPlatform', configByPlatform.cumaAIButtonString);
        window.open(url.toString());
    }, []);

    return (
        <Container>
            {isHovering && <div className="text">도움이 필요하신가요??</div>}
            <button
                onClick={onClick}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <img width={50} height={50} src="/ic_ai_cuma.svg" alt="ai 쿠마 버튼" />
            </button>
        </Container>
    );
}

export default CumaAIButton;
